export function isW(str) {
    if (!str) {
        return true;
    }
    return /^\w+$/.test(str);
}
export function include(str, ...strings) {
    if (!str) {
        return false;
    }
    if (strings.length < 1) {
        return true;
    }
    try {
        strings.forEach(s => {
            if (str.includes(s)) {
                throw new Error('true');
            }
        });
    }
    catch (e) {
        return e.message;
    }
    return false;
}
export function includeAll(str, ...strings) {
    if (!str) {
        return false;
    }
    if (strings.length < 1) {
        return true;
    }
    try {
        strings.forEach(s => {
            if (!str.includes(s)) {
                throw new Error('false');
            }
        });
    }
    catch (e) {
        return e.message;
    }
    return true;
}
export default { isW, include, includeAll };
